import { combineReducers } from '@reduxjs/toolkit';
import orderSlice from './reducers/orderSlice';
import returnSlice from './reducers/returnSlice';
import configSlice from './reducers/configSlice';
import decisionCodeSlice from './reducers/decisionCodeSlice';
import navigationSlice from './reducers/navigationSlice';
import companiesSlice from './reducers/companiesSlice';
import usersSlice from './reducers/usersSlice';
import adminSlice from './reducers/adminSlice';
import skuLocationSlice from './reducers/skuLocationSlice';
import alertSlice from './reducers/alertSLice';
import batchReturnSlice from './reducers/batchReturnSlice';
import intercompanySlice from './reducers/intercompanySlice';

export default combineReducers({
    orders: orderSlice,
    returns: returnSlice,
    config: configSlice,
    decisionCode: decisionCodeSlice,
    navigation: navigationSlice,
    companies: companiesSlice,
    users: usersSlice,
    admin: adminSlice,
    skuLocation: skuLocationSlice,
    alert: alertSlice,
    batchReturn: batchReturnSlice,
    intercompany: intercompanySlice,
});
